import { render, staticRenderFns } from "./PriceFreeByCondition.vue?vue&type=template&id=03146abc&"
import script from "./PriceFreeByCondition.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PriceFreeByCondition.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03146abc')) {
      api.createRecord('03146abc', component.options)
    } else {
      api.reload('03146abc', component.options)
    }
    module.hot.accept("./PriceFreeByCondition.vue?vue&type=template&id=03146abc&", function () {
      api.rerender('03146abc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DoctorPriceBlockV2/components/PriceFreeByCondition.vue"
export default component.exports